module.exports = __webpack_public_path__ + "img/medical.60ed19f8.svg";